import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { blocksApi, type BlockListParams } from '../api/content-api';

import { contentKeys } from './content-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). `storeId` null lists shared blocks. */
export function blockListQueryOptions(storeId: string | null, params: BlockListParams) {
  return queryOptions({
    queryKey: contentKeys.blockList(storeId, params),
    queryFn: () => blocksApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useBlocks(storeId: string | null, params: BlockListParams) {
  return useQuery(blockListQueryOptions(storeId, params));
}
